/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BannerCategory from '../components/BannerCategory';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerOverline from '../components/BannerOverline';
import BannerSubtitle from '../components/BannerSubtitle';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class ThaliaReadingMaterial extends AbstractLayout {
	get key() {
		return 'thalia_reading_material';
	}

	content() {
		const { banner } = this.attrs;
		const backgroundColor = banner.visual()?.bg_color?.default;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<div className="BannerContentContainer">
						<BannerTitle banner={banner} />
						<BannerSubtitle banner={banner} />
						<BannerTeaser banner={banner} />
						<BannerOverline banner={banner} />
						<BannerCategory banner={banner} />
						<BannerLinkButton banner={banner} />
					</div>

					<div className="BannerImageWrapper" style={{ '--banner-bg': backgroundColor }}>
						<BannerImage banner={banner} />
						<Disruptor banner={banner} />
					</div>
				</div>
			</LinkWrapper>
		);
	}
}
